import { combineReducers } from 'redux'
import deleting from 'components/ties/reducers/deleting'

export default combineReducers({ deleting })
